export class PaymentsHttp {
    /**
     * Create a card payment
     * @param card
     * @param amount
     * @param email
     * @param stripeId
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async createPayment(card, amount, email, stripeId) {
        try {
            return await window.axios.post(`payments/intent`, {
                card: card,
                amount: amount,
                email: email,
                customerId: stripeId
            });
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Create an offline payment
     * @param amount
     * @param stripeId
     * @return {Promise<AxiosResponse<any>>}
     */
    static async createPaymentOffline(amount, stripeId) {
        try {
            return await window.axios.post(`payments/intent/offline`, {
                amount: amount,
                customerId: stripeId
            });
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Update stripe charges if needed
     * @param xeroInvoiceNumber
     * @param payments
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async updateCharges(xeroInvoiceNumber, payments) {
        try {
            return await window.axios.put(`payments/charges`, {
                xeroInvoiceNumber: xeroInvoiceNumber,
                paymentRefs: payments
            });
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Create a customer
     * @param customer
     * @return {Promise<AxiosResponse<any>>}
     */
    static async createCustomer(customer) {
        try {
            return await window.axios.post(`payments/customer`, {
                customer
            });
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Get a customer
     * @param stripeId
     * @return {Promise<AxiosResponse<any>>}
     */
    static async getCustomer(stripeId) {
        try {
            return await window.axios.get(`payments/customer/${stripeId}`);
        } catch (e) {
            return await Promise.reject(e);
        }
    }
}
